<template>
  <div>
    <b-modal size="lg" v-model="show" @hidden="$emit('hidden')">
      <template #modal-header>
        <h5 class="text-primary">
          {{ $t("Review Justification") }}
        </h5>

        <b-badge
          :variant="
            justification.status == 'Approved By HR'
              ? 'light-success'
              : 'light-danger'
          "
          class="ml-2"
        >
          {{ $t(justification.status) }}
        </b-badge>
      </template>

      <template #modal-footer>
        <div class="text-right">
          <b-button variant="outline-danger" @click="$emit('hidden')">
            {{ $t("close").toUpperCase() }}
          </b-button>
        </div>
      </template>

      <b-row class="my-1">
        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider v-slot="{ errors }" name="justification_type">
            <b-form-group
              :label="$t('Justification Type')"
              :state="errors[0] ? false : null"
            >
              <v-select
                v-model="justification.justification_type_id"
                id="justification_type"
                :clearable="false"
                :reduce="(value) => value.id"
                label="name"
                disabled
                :options="justificationTypes"
                :get-option-label="(option) => $t(option.name)"
              >
              </v-select>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider name="start_date">
            <b-form-group :label="$t('Date')">
              <kendo-datepicker
                class="form-control-kendo"
                :format="'dd-MM-yyyy'"
                v-model="justification.date"
                autofocus
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                disabled
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col v-if="esTardanza" cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider name="aplicar_descuento">
            <b-form-group label="¿Aplicar descuento por tardanza?">
              <b-form-checkbox
                class="mt-05"
                v-model="justification.aplicar_descuento"
                switch
                disabled
              ></b-form-checkbox>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <validation-provider v-slot="{ errors }" name="observation">
            <b-form-group
              :label="$t('Observation')"
              :state="errors[0] ? false : null"
            >
              <b-form-textarea
                v-model="justification.observation"
                :rows="3"
                :max-rows="6"
                disabled
                :placeholder="$t('Enter your text')"
              ></b-form-textarea>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    personal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      mode: "single",
      justificationTypes: [],
      justification: {
        justification_type_id: null,
        observation: "",
        employee_id: "",
        created_by: "",
        file: null,
        start_date: "",
        end_date: "",
        date: "",
      },
    };
  },
  mounted() {
    this.addPreloader();
    Promise.all([this.listJustificationTypes(), this.getJustificationByDate()]);
    this.removePreloader();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    esTardanza() {
      return this.justification.justification_type_id == 3;
    },
  },
  methods: {
    async getJustificationByDate() {
      try {
        let form = {
          employee_id: this.personal.personal_id,
          start_date: this.personal.startDate,
        };

        const { data } = await AttendanceService.getJustificationByDate(form);
        console.log("data: ", data);
        if(data && data.justifications && data.justifications.length > 0) {
          console.log("ingresa...")
          this.justification = data.justifications[0];
          this.justification.date = moment(this.justification.date).format("DD-MM-YYYY");
          this.justification.aplicar_descuento = this.justification.aplicar_descuento === 1 ? true : false;
        } else {
          this.justification = {
            justification_type_id: null,
            observation: "",
            employee_id: this.personal.personal_id,
            created_by: this.currentUser.id,
            file: null,
            start_date: this.personal.startDate,
            end_date: "",
            date: moment(this.personal.startDate).format("DD-MM-YYYY"),
            aplicar_descuento : false
          };
        }
        // this.justification = data;
      } catch (error) {
        console.log(error);
      }
    },

    async listJustificationTypes() {
      try {
        const { data } = await AttendanceService.listJustificationTypes();
        this.justificationTypes = data;
      } catch (error) {
        this.showToastError();
      }
    },
  },
};
</script>